<template>
  <v-app>
    <core-snack />

    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="isLogin || isLogout"
        class="fill-height"
      >
        <router-view />
      </div>

      <div
        v-else
        class="fill-height"
      >
        <v-navigation-drawer
          class="elevation-10"
          width="200px"
          app
          permanent
          clipped-left
        >
          <v-list
            class="fill-height pt-0"
            shaped
          >
            <v-list-item
              class="align-center justify-center toHover"
              style="margin-top: -18px;"
            >
              <img
                src="/img/komacut.svg"
                width="100px"
                height="64px"
                class="logo"
                @click="$router.push('/')"
              >
            </v-list-item>

            <v-list-item class="justify-center">
              <v-btn
                id="instantQuote"
                color="green"
                dark
                @click="onActionButtonClicked"
              >
                {{ actionButtonText }}
              </v-btn>
            </v-list-item>

            <v-row
              style="height: 70%"
              align="center"
            >
              <v-col>
                <div class="menu">
                  <template v-for="(link, i) in links">
                    <v-list-item
                      v-if="!_.get(menuItemState, [link.to, 'hidden'])"
                      :key="i"
                      class="toHover"
                      :to="link.to"
                      :disabled="_.get(menuItemState, [link.to, 'disabled'])"
                    >
                      <v-list-item-title class="text-center">
                        <v-row justify="center">
                          <v-col cols="auto">
                            <v-img
                              id="selectedItem"
                              :src="link.src"
                              max-width="40"
                              max-height="40"
                            />
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col class="pt-0">
                            {{ link.label }}
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </div>
              </v-col>
            </v-row>

            <v-footer
              class="px-0"
              style="background: transparent"
              absolute
            >
              <v-list
                class="py-0"
                two-line
                shaped
              >
                <v-list-item>
                  <v-list-item-avatar class="mr-2">
                    <img src="/img/help-avatar.svg">
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="caption">
                        {{ $t('menu.needhelp') }}
                      </span>
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      <span class="font-weight-bold">
                        {{ $t('menu.getintouch') }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-footer>
          </v-list>
        </v-navigation-drawer>

        <v-content class="fill-height">
          <keep-alive>
            <router-view />
          </keep-alive>
        </v-content>
      </div>
    </transition>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import appMenus from './menu';
import AuthMixin from './mixins/auth';
import StatesMixin from './mixins/states';

/** Add/replace client's menu */
import komacutMenus from './_komacut/menu';

export default {
  name: 'App',

  mixins: [
    AuthMixin,
    StatesMixin,
  ],

  data() {
    return {
      menuItemState: {},
    };
  },

  computed: {
    ...mapState('app', [
      'image', 'sidebarBackgroundColor', 'title', 'logo', 'locale',
    ]),

    allMenuItems() {
      return [
        ...this.links,
      ];
    },

    links() {
      return [
        ...appMenus.links.call(this),

        /** Add/replace client's link menu items */
        ...komacutMenus.links.call(this),
      ];
    },

    isLogin() {
      return this.$route.fullPath === '/login';
    },

    isLogout() {
      return this.$route.fullPath === '/logout';
    },

    actionButtonText() {
      return 'Instant Quote';
    },
  },

  watch: {
    'user.rights': function userRights() {
      this.processMenuItems();
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$i18n.locale = this.locale;
    });
  },

  methods: {
    processMenuItems() {
      _.each(this.allMenuItems, (item) => this.processStates(item, [
        'disabled', 'hidden',
      ], item.to, 'menuItemState'));
    },

    onActionButtonClicked() {
      this.$router.push('/rfqs/new');
    },
  },
};
</script>

<style scoped>
  .v-list-item {
  font-size: 12px;
  height: 100px;
}
.tiny-font {
  font-size: 10px;
}
.tiny-font-bold {
  font-size: 10px;
  font-weight: bold;
}

.toHover:hover {
  color: #6cb043;
  filter: invert(0.4) sepia(1) saturate(4) hue-rotate(75.6deg) brightness(1);
}

.v-navigation-drawer__content .v-list-item--active {
  color:  #6cb043;
  filter: invert(0.4) sepia(1) saturate(4) hue-rotate(75.6deg) brightness(1);
}

.v-image__image--contain {
  top: 9px;
  height: 60%;
}
.search-input {
  margin-bottom: 30px !important;
  padding-left: 15px;
  padding-right: 15px;
}
div.v-responsive.v-image > div.v-responsive__content {
  overflow-y: auto;
}
</style>

<style scoped>
.logo:hover {
  cursor: pointer;
}
.menu {
  max-height: calc(100vh - 120px);
  overflow-y: auto;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>

<style>
header.v-sheet.v-toolbar.v-toolbar--flat.v-app-bar {
  background-color: #f5f5f5 !important;
}

.theme--light.v-application {
  background: #f5f5f5 !important;
}

.v-navigation-drawer {
  z-index: 11 !important;
}

.v-content {
  padding-top: 64px !important;
}

.v-card__title {
  padding: 8px 8px 8px;
}

.v-toolbar__content {
  height: 64px !important;
}

.v-app-bar.v-app-bar--fixed {
  z-index: 7 !important;
}

.disabled {
  color: rgba(0,0,0,.38);
}

.v-list--nav .v-list-item {
  padding: 0 6px;
}

.v-list-item__action {
  margin: 6px 0;
}

.v-list-item__icon {
  margin: 8px 0;
}

.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 16px;
}

.v-list--dense .v-list-item, .v-list-item--dense {
  min-height: 32px;
}

.v-data-table td {
  height: 36px;
}

.v-data-table td, .v-data-table th {
  padding: 0 4px;
}

.v-data-table tr td {
  cursor: default;
}

.col, .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col-auto, .col-lg, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-auto, .col-md, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md-auto, .col-sm, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-auto {
  padding: 6px;
}

.v-input__slot {
  margin-bottom: 2px;
}

.v-expansion-panel-header {
  padding: 8px 16px;
}

.v-select.v-text-field input {
    display: none;
}
</style>
